module.exports = __webpack_public_path__ + "static/media/sad-empty-state-opened.dcdc0e39.png";